const initialState = {
  data: {},
  documentVerified: '',
};

export const documentUpload = {
  state: { ...initialState },
  reducers: {
    updateDocumentDetails(state, payload) {
      return { ...state, data: { ...state.data, ...payload } };
    },
    clearDocumetDetails() {
      return { ...initialState };
    },
    updateVerifyStatus(state, payload) {
      return {
        ...state,
        documentVerified: payload,
      };
    },
  },
  effects: (dispatch) => {
    return {};
  },
};
